import toPairs from "lodash/toPairs";
import reduce from "lodash/reduce";
import isObject from "lodash/isObject";
import isString from "lodash/isString";

// this contains object property names whose values we want to omit
const OBJECT_PROPERTIES_TO_REPLACE = ["password"];

// this contains regex to match with string values
// the regex must contain 3 capture groups - a prefix, the value to be omitted and a suffix - where
// anything matching the second capture group will be omitted
const STRING_PATTERNS_TO_REPLACE = [/(\"password\":\")(.*?)(\")/];

export const removeSensitiveData = (data?: unknown) => {
  if (isObject(data)) {
    return reduce(
      toPairs(data),
      (result: Record<string, unknown>, [key, value]) => {
        result[key] =
          OBJECT_PROPERTIES_TO_REPLACE.indexOf(key) !== -1
            ? "[omitted]"
            : isObject(value) || isString(value)
            ? removeSensitiveData(value)
            : value;

        return result;
      },
      {},
    );
  }

  if (isString(data)) {
    return reduce(
      STRING_PATTERNS_TO_REPLACE,
      (result, regex) => {
        return result.replace(regex, "$1[omitted]$3");
      },
      data,
    );
  }

  return data;
};
